module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Sport1-18fad1431afb40ac6d310112fd5548b3.png";